const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be']

/**
 * Returns an error message if the URL is a YouTube playlist, channel, or other non-video page.
 * Returns null if the URL is fine (either not YouTube, or a valid video URL).
 */
export function getYouTubeUrlError(url: string): string | null {
  try {
    const parsed = new URL(url)
    const host = parsed.hostname.toLowerCase()

    if (!YOUTUBE_HOSTS.includes(host)) return null

    if (parsed.pathname === '/playlist') {
      return 'YouTube playlist URLs are not supported. Please provide a direct video URL (e.g. youtube.com/watch?v=...).'
    }

    if (
      parsed.pathname.startsWith('/@') ||
      parsed.pathname.startsWith('/channel/') ||
      parsed.pathname.startsWith('/c/')
    ) {
      return 'YouTube channel URLs are not supported. Please provide a direct video URL.'
    }

    if (parsed.pathname === '/watch' && parsed.searchParams.has('list') && !parsed.searchParams.has('v')) {
      return 'This appears to be a playlist URL. Please provide a direct video URL instead.'
    }

    return null
  } catch {
    return null
  }
}
